/* eslint-disable tailwindcss/no-unnecessary-arbitrary-value */

import { cva, cx, VariantProps } from "cva";

const LandingPageContentStyles = cva("relative mx-auto w-full", {
  variants: {
    maxWidth: {
      small: "md:max-w-[680px]",
      medium: "md:max-w-[1024px]",
      large: "md:max-w-[1360px]",
      memo: "md:max-w-[744px]",
    },
  },
  defaultVariants: {
    maxWidth: "medium",
  },
});

export type LandingPageContentProps<T extends React.ElementType> = {
  as?: T;
  children: React.ReactNode;
  className?: string;
} & VariantProps<typeof LandingPageContentStyles> &
  React.ComponentPropsWithoutRef<T>;

export const LandingPageContent = <T extends React.ElementType = "footer">({
  as,
  children,
  className,
  maxWidth,
  ...rest
}: LandingPageContentProps<T>) => {
  const Component = as || "div";
  return (
    <Component
      className={cx(
        LandingPageContentStyles({
          maxWidth,
        }),
        className
      )}
      {...rest}
    >
      <div className="px-xs md:px-s lg:px-m">{children}</div>
    </Component>
  );
};
